var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m813.79 1012.5c-255.68 0-626.29-366.93-626.29-626.43 0-102.47 64.059-198.56 173.47-198.56 22.961 0 126.56 176.88 126.56 198.7 0 35.715-106.15 87.871-106.15 119.48 0 76.816 236.12 312.93 312.93 312.93 31.605 0 83.762-106.15 119.48-106.15 6.6602 0 191.33 97.648 197 114.38 39.117 90.988-106.86 185.66-197 185.66z",
    fill: "#01447a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelico);
export default __webpack_public_path__ + "static/media/telico.c38456e552cf6af2857793b9b21bdaf8.svg";
export { ForwardRef as ReactComponent };